import React, { useState, useEffect, useRef } from 'react';
import '../styles/ChatMonitor.css';
import { getAllChats, sendAdminMessage, closeChat } from '../services/api';

function ChatMonitor() {
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [message, setMessage] = useState('');
  const chatEndRef = useRef(null);

  useEffect(() => {
    const fetchChats = async () => {
      try {
        const data = await getAllChats();
        setChats(data);
      } catch (err) {
        console.error('Failed to fetch chats:', err);
      }
    };
    fetchChats();
    const interval = setInterval(fetchChats, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleSend = async (e) => {
    e.preventDefault();
    if (message.trim() && selectedChat) {
      try {
        const messageData = { text: message, sender: 'admin', timestamp: new Date().toLocaleString() };
        await sendAdminMessage(selectedChat.id, messageData);
        setChats(chats.map(chat => chat.id === selectedChat.id ? {
          ...chat,
          messages: [...chat.messages, { id: chat.messages.length + 1, ...messageData }],
        } : chat));
        setMessage('');
      } catch (err) {
        alert('Failed to send message.');
      }
    }
  };

  const handleCloseChat = async (chatId) => {
    if (window.confirm('Are you sure you want to close this chat?')) {
      try {
        await closeChat(chatId);
        setChats(chats.map(chat => chat.id === chatId ? { ...chat, status: 'Closed' } : chat));
        if (selectedChat?.id === chatId) setSelectedChat({ ...selectedChat, status: 'Closed' });
      } catch (err) {
        alert('Failed to close chat.');
      }
    }
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [selectedChat?.messages]);

  return (
    <div className="ap-chat-monitor">
      <h2 className="ap-chat-title">Chat Monitor</h2>
      <div className="ap-chat-container">
        <div className="ap-chat-list">
          {chats.map(chat => (
            <div
              key={chat.id}
              className="ap-chat-item"
              onClick={() => setSelectedChat(chat)}
            >
              <span>{chat.clientName}</span>
              <span>{chat.lastMessage}</span>
              <span className={`ap-chat-status ${chat.status === 'Closed' ? 'ap-closed' : ''}`}>{chat.status}</span>
            </div>
          ))}
        </div>
        {selectedChat && (
          <div className="ap-chat-details">
            <h3 className="ap-chat-details-title">{selectedChat.clientName}'s Chat</h3>
            <div className="ap-chat-window">
              {selectedChat.messages.map((msg) => (
                <div
                  key={msg.id}
                  className={`ap-chat-message ${msg.sender === 'client' ? 'ap-client-message' : 'ap-admin-message'}`}
                >
                  <p className="ap-message-text">{msg.text}</p>
                  <span className="ap-message-timestamp">{msg.timestamp}</span>
                </div>
              ))}
              <div ref={chatEndRef} />
            </div>
            {selectedChat.status !== 'Closed' && (
              <form className="ap-chat-form" onSubmit={handleSend}>
                <input
                  className="ap-chat-input"
                  type="text"
                  placeholder="Type your message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <button className="ap-chat-btn" type="submit">Send</button>
                <button className="ap-close-btn" type="button" onClick={() => handleCloseChat(selectedChat.id)}>Close Chat</button>
              </form>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatMonitor;